module.exports = __webpack_public_path__ + "assets/img/underrefurbishment.850f35e9.svg";